import { Dtos } from "@inrev/common";
import { computeExpirationItems } from "./computeExpirationItems";
import { computeIndemnityItems, isApprovedOrActive } from "./computeIndemnityItems";
import { computeMissingInfoItems } from "./computeMissingInfoItems";
import type { ActionItem } from "./types";

export type ComputeActionItemsInput = {
	account: Pick<
		Dtos.SuretyAccount.Get.Response,
		"status" | "modelSize" | "isContractSuretyAccount"
	> & { history: Dtos.SuretyAccount.Metadata.Get.Response };
	individuals: Dtos.Individual.Get.Response[];
	latestWipStatement: Dtos.WipStatement.Get.Response | null | undefined;
	latestIndemnityAgreement: Dtos.SuretyAccount.IndemnityAgreement.Get.Response | null | undefined;
	financialPeriods?: Dtos.Admin.FinancialPeriod.Get.Response[] | null;
	financialExtractions?: Dtos.FinancialExtraction.Get.Response[] | null;
	showContractHistory?: boolean;
};

export function computeActionItems(input: ComputeActionItemsInput): ActionItem[] {
	return [
		...computeExpirationItems(input),
		...(!isApprovedOrActive(input.account.status) ? computeMissingInfoItems(input) : []),
		...computeIndemnityItems(input),
	];
}
